if (!window.indexedDB) {
    alert(
        `Your browser doesn't support a stable version of IndexedDB. 
    Storing user profiles, applications and preferences will not be available. 
    Please try using regular (not private) browser mode or adjust browser settings to allow for local storage`
    );
}
